import { AsyncPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

import { Menu, MenuComponent } from './shared/menu/menu.component';
import { MenuService } from './shared/menu/menu.service';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { LoaderComponent } from "./shared/loader/loader.component";
import { OneSignal } from "onesignal-ngx";
import {environment} from "../environments/environment";
import { NotificationService } from "./shared/services/notification/notification.service";
@Component({
  selector: 'app-root',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    RouterOutlet,
    MenuComponent,
    NavbarComponent,
    AsyncPipe,
    HttpClientModule,
    LoaderComponent
],
})
export class AppComponent implements OnInit {
  title = 'Escolar Ai';
  isMenu: Menu[] = [];

  constructor(
    private menuService: MenuService,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private notificationService : NotificationService,
    private oneSignal: OneSignal
  ) {
    this.menuService._menu.subscribe((menu) => {
      this.isMenu = menu;
    });
    this.oneSignal.init({
      appId: environment.ONE_SIGNAL_APP_ID,
    }).then(() => {
      console.log('Carregou One Signal')
    }).catch((err) => {
      console.log(err)
    });
    // notificationService.listenNewNotifications()
  }
  ngOnInit() {}
}
